import { useLazyQuery } from '@apollo/client/react';
import debounce from 'lodash/debounce';
import ms from 'ms';
import { useCallback, useMemo, useState } from 'react';
import GET_CANNED_RESPONSES from './queries/GetCannedResponses';

const useCannedResponses = function (partnerId, { skip } = {}) {
  const [responses, setResponses] = useState([]);
  const hasResponses = responses.length > 0;
  const [getCannedResponses] = useLazyQuery(GET_CANNED_RESPONSES);

  const lookupCompletions = useMemo(
    () =>
      debounce(async (command) => {
        try {
          const { data } = await getCannedResponses({
            variables: {
              prefix: command.substring(1),
              partnerId,
              first: 5,
            },
          });
          const { cannedResponses: { edges } = {} } = data.partner;
          const cannedResponses = edges.map(({ node }) => node);
          setResponses(cannedResponses);
        } catch (err) {
          if (err.name === 'AbortError') return;
          throw err;
        }
      }, ms('0.2s')),
    [partnerId, getCannedResponses],
  );

  const handleInputChange = useCallback(
    (value) => {
      if (skip) return;

      const command = value.trim();
      if (!command.startsWith('/')) {
        if (hasResponses) {
          setResponses([]);
        }
      } else if (command.length > 1) {
        lookupCompletions(command);
      }
    },
    [hasResponses, lookupCompletions, skip],
  );

  return [handleInputChange, responses];
};

export default useCannedResponses;
